import { css } from '@emotion/react'

export const root = css({
  height: '100%',
})
